import * as types from '@/store/mutation-types'

export default {
    [types.SET_BUSINESS_LIST](state, data) {
        state.businessList = data
    },
    [types.SET_USER_SELECTED_ACCOUNT](state, business) {
        state.selectedBusiness = business
    },
    [types.SET_BUSINESS_BRANDING](state, branding) {
        state.activeBusinessBranding = branding
    }
}
